import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphql } from '@/generated/gql/gql';
import { PersonalInfoInput } from '@/generated/gql/graphql';
import { gqlClient } from '@/lib/gqlClient';
import { useToken } from '@/utils/token';

const UPDATE_USER_LANGUAGE = graphql(`
  mutation UpdateUserLanguage($users: [UserInput!]) {
    users(users: $users) {
      success
    }
  }
`);

const useUpdateUserLanguage = () => {
  const queryClient = useQueryClient();
  const { tokenContent } = useToken();
  const authServiceUuid = tokenContent?.payload?.user?.uuid ?? '';

  return useMutation({
    mutationKey: ['updateUserLanguage'],
    mutationFn: ({ locale }: PersonalInfoInput) => {
      const input = {
        users: [
          {
            id: authServiceUuid,
            personalInfo: {
              locale,
            },
          },
        ],
      };

      return gqlClient.request(UPDATE_USER_LANGUAGE, input);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-details'],
      });
    },
  });
};

export default useUpdateUserLanguage;
